import React from 'react';
import { Cookie } from 'lucide-react';
import { useCookieConsent } from '../../site/CookieConsent';
import { useI18n } from '../../i18n/LanguageContext';

const LABELS: Record<string, string> = {
  de: 'Cookie-Einstellungen',
  en: 'Cookie settings',
  it: 'Impostazioni cookie',
};

/** Small persistent button (bottom-left) to reopen the cookie choice after a decision. */
const CookiePrefsButton: React.FC = () => {
  const { bannerOpen, prefsOpen, openPreferences } = useCookieConsent();
  const { lang } = useI18n();
  if (bannerOpen || prefsOpen) return null; // banner or preferences already visible
  const label = LABELS[lang] || LABELS.en;

  return (
    <button type="button" className="cookie-fab" onClick={openPreferences} aria-label={label} title={label}>
      <Cookie size={20} aria-hidden />
    </button>
  );
};

export default CookiePrefsButton;
